/* Bomb Pack v5 — our own button only, ignores theme buttons, live stock labels */
(function(){
  // Product handles for tees and hats
  const TEE_HANDLES = {
    "Discipline Black":  "discipline-heavyweight-black-tee",
    "Discipline White":  "discipline-heavyweight-white-tee",
    "Dedication Black":  "dedication-heavyweight-black-tee",
    "Dedication White":  "dedication-heavyweight-white-tee"
  };
  const HAT_HANDLES = {
    "R-Logo Hat Black Limited Edition": "r-logo-hat-black-limited-edition",
    "R-Logo Hat Off-White Black Rim Limited Edition": "r-logo-hat-black"
  };

  // Selectors for our inputs and button
  const SEL = {
    tee1:  '#ry-tee1',
    size1: '#ry-size1',
    tee2:  '#ry-tee2',
    size2: '#ry-size2',
    hat:   '#ry-hat',
    btn:   '#bp-add',
    msg:   '#ry-pack-msg'
  };

  const $ = s => document.querySelector(s);
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn);

  // small message helper
  function msg(txt, ok){
    const el = $(SEL.msg);
    if (!el) return;
    el.textContent = txt || '';
    el.style.color = ok ? '#0a7d28' : '#b00020';
  }

  // status helpers
  function ensureStatusEl(afterSelect, id){
    if (!afterSelect) return null;
    let el = document.getElementById(id);
    if (!el){
      el = document.createElement('div');
      el.id = id;
      el.className = 'ry-status';
      el.style.fontSize = '14px';
      el.style.lineHeight = '1.2';
      el.style.margin = '6px 0 10px';
      el.style.fontWeight = '700';
      afterSelect.insertAdjacentElement('afterend', el);
    }
    return el;
  }
  function setStatus(el, ok, text){
    if (!el) return;
    el.textContent = text || '';
    el.style.color = ok ? '#0a7d28' : '#b00020';
  }

  // fetch with cache
  const cache = {};
  async function getProduct(handle){
    if (cache[handle]) return cache[handle];
    const r = await fetch(`/products/${handle}.js`, { credentials:'same-origin' });
    if (!r.ok) throw new Error('Load failed ' + handle);
    const data = await r.json();
    cache[handle] = data;
    return data;
  }
  async function findVariant(handle, size){
    const p = await getProduct(handle);
    const v = p.variants.find(v => [v.option1, v.option2, v.option3].includes(size));
    return v ? { id: v.id, available: v.available, title: v.title } : null;
  }

  async function updateStatuses(){
    try{
      const tee1Name = $(SEL.tee1)?.value;
      const size1    = $(SEL.size1)?.value;
      const tee2Name = $(SEL.tee2)?.value;
      const size2    = $(SEL.size2)?.value;
      const hatName  = $(SEL.hat)?.value;

      const s1 = ensureStatusEl($(SEL.size1), 'ry-status1');
      const s2 = ensureStatusEl($(SEL.size2), 'ry-status2');
      const sh = ensureStatusEl($(SEL.hat),   'ry-status-hat');

      if (tee1Name && size1){
        const v1 = await findVariant(TEE_HANDLES[tee1Name], size1);
        setStatus(s1, !!(v1 && v1.available), v1 && v1.available ? 'In stock' : 'Sold out');
      } else setStatus(s1, true, '');

      if (tee2Name && size2){
        const v2 = await findVariant(TEE_HANDLES[tee2Name], size2);
        setStatus(s2, !!(v2 && v2.available), v2 && v2.available ? 'In stock' : 'Sold out');
      } else setStatus(s2, true, '');

      if (hatName){
        const p = await getProduct(HAT_HANDLES[hatName]);
        const hv = p.variants[0];
        setStatus(sh, hv && hv.available, hv && hv.available ? 'In stock' : 'Sold out');
      } else setStatus(sh, true, '');

      msg('', true);
    }catch(e){ /* silent */ }
  }

  async function addPack(){
    const btn = $(SEL.btn);
    const tee1Name = $(SEL.tee1)?.value;
    const size1    = $(SEL.size1)?.value;
    const tee2Name = $(SEL.tee2)?.value;
    const size2    = $(SEL.size2)?.value;
    const hatName  = $(SEL.hat)?.value;

    if (!tee1Name || !size1 || !tee2Name || !size2 || !hatName){
      msg('Select both tees with sizes and a hat.', false);
      return;
    }

    try{
      if (btn) { btn.disabled = true; }

      const [v1, v2, hv] = await Promise.all([
        findVariant(TEE_HANDLES[tee1Name], size1),
        findVariant(TEE_HANDLES[tee2Name], size2),
        getProduct(HAT_HANDLES[hatName]).then(p => p.variants[0])
      ]);

      if (!v1 || !v1.available){ msg(`${tee1Name} ${size1} is sold out.`, false); return; }
      if (!v2 || !v2.available){ msg(`${tee2Name} ${size2} is sold out.`, false); return; }
      if (!hv || !hv.available){ msg(`${hatName} is sold out.`, false); return; }

      const payload = { items: [
        { id: v1.id, quantity: 1, properties: { "_Bundle": "Bomb Pack", "Role": "Tee 1" } },
        { id: v2.id, quantity: 1, properties: { "_Bundle": "Bomb Pack", "Role": "Tee 2" } },
        { id: hv.id, quantity: 1, properties: { "_Bundle": "Bomb Pack", "Role": "Hat" } }
      ]};

      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept':'application/json' },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      });

      if (!r.ok){
        const err = await r.json().catch(()=>({description:'Add failed'}));
        throw new Error(err.description || 'Add failed');
      }

      // force cart view to avoid any drawer issues
      window.location.href = '/cart';
    }catch(err){
      msg(err.message || 'Could not add to cart.', false);
    }finally{
      if (btn) { btn.disabled = false; }
      updateStatuses();
    }
  }

  function wire(){
    // show statuses
    ensureStatusEl($(SEL.size1), 'ry-status1');
    ensureStatusEl($(SEL.size2), 'ry-status2');
    ensureStatusEl($(SEL.hat),   'ry-status-hat');

    [SEL.tee1, SEL.size1, SEL.tee2, SEL.size2, SEL.hat].forEach(s => {
      on($(s), 'change', updateStatuses);
    });

    const btn = $(SEL.btn);
    if (btn && !btn._ryBound){
      btn._ryBound = true;
      on(btn, 'click', addPack);
      on(btn, 'touchend', function(e){ e.preventDefault(); addPack(); });
      // make sure it is always clickable even if theme overlays something
      btn.style.pointerEvents = 'auto';
      btn.style.zIndex = '5';
      btn.style.position = 'relative';
    }

    updateStatuses();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  document.addEventListener('shopify:section:load', wire);
})();